import { useState } from 'react';
import { faqData } from '@/data/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-semibold mb-3">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Często Zadawane Pytania
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Znajdź odpowiedzi na najczęściej zadawane pytania dotyczące Kakobuy Spreadsheet.
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h4 className="font-semibold text-sm md:text-base text-foreground-900 pr-6">
                  {item.question}
                </h4>
                <span
                  className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full transition-all ${
                    openIndex === idx
                      ? 'bg-primary-500 text-white rotate-180'
                      : 'bg-background-100 text-foreground-500'
                  }`}
                >
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-[800px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}